export default function common() {
  $(() => {
    setTimeout(() => {
      $(".l-header").removeClass('is-lock');
    }, 100);
    $("#scroll").on('click', function () {
      $("html,body").animate({ scrollTop: 0 }, 500, "swing");
    });

    // footer
    $(".switch").on('click', function () {
      $(this)
        .next()
        .slideToggle();
      $(this).toggleClass("switch-on");
    });

    $(".js-menu-button").on('click', function (e) {
      e.preventDefault();
      $(this)
        .prev()
        .slideToggle(300);
    });

    $('a[href^="tel:"]').on('click', function (event) {
      const className = $(this).attr('class');
      if (className !== 'modal-btn') {
        event.preventDefault();
        $('#modal').addClass('is-active');
      }
    });

    $('.modal-bg').on('click', function () {
      $('#modal').removeClass('is-active');
    });

    $("#open-menu").on('click', function (e) {
      e.preventDefault();
      if ($("#jumbo .menu").css("display") === "none") {
        $("#jumbo .menu").slideDown(300);
      } else {
        $("#jumbo .menu").slideUp(300);
      }
    });

    $(".sp-menu a").on('click', function (e) {
      e.preventDefault();
      if ($(".l-header .header-button").css("display") === "none") {
        $(".l-header .header-button").toggleClass("is-open");
        $("body").toggleClass("is-open");
        $(".l-header .header-button").slideDown(300);
      } else {
        $(".l-header .header-button").toggleClass("is-open");
        $("body").toggleClass("is-open");
        $(".l-header .header-button").slideUp(300);
      }
    });

    function commonSwitch() {

    }
    if ($('body').hasClass('home')) {
      $(".nav-item--menu > a").on('click', function (e) {
          e.preventDefault();
          $(".l-header .header-button").toggleClass("is-open");
          $("body").toggleClass("is-open");
          $(".l-header .header-button").slideUp(300);
          var targetUrl = $(this).attr('href');
          window.location.href = targetUrl;
      });
    }

    $(window).on("resize", function () {
      const wid = $(window).width();
      if ($('.header-about').length > 0) {
        if (wid <= 767) {
          $('.header-button').append($('.about-nav'));
          $('.footer-contents-nav .switch').after($('.footer-menu-nav'));
        } else {
          $('.header-about').prepend($('.about-nav'));
          $('.footer-menu-list-2').before($('.footer-menu-nav'));
          $('.header-button').removeAttr('style');
        }
      }
    })


    const wid = $(window).width();
    if (wid <= 767) {
      if ($('.header-about').length > 0) {
        $('.header-button').append($('.header-about > nav'));
      }
      $('.footer-contents-nav .switch').after($('.footer-menu-nav'));
    } else {
      $('.footer-menu-list-2').before($('.footer-menu-nav'));
    }

  });
}
